module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Map/Direction#2-468c5b2d33febc8570f84d5a8774401e.svg";